import { httpService } from '@/api/v1/http.service'
import { type InfiniteQueryOptions } from '@/types/infinite-query'
import { type LabelAndValue } from '@/types/label-and-value'
import { nextPageParamGetter } from '@/utils/next-page-param-getter'
import { parsePaginatedOptions } from '@/utils/parse-paginated'

type Params = {
  search?: string
  semesterId?: string
}

export const availabilityUsersQueryOptions = (
  params: Params
): InfiniteQueryOptions<LabelAndValue> => ({
  queryKey: ['panelUsersAvailabilityOptionsIdsList', params],
  staleTime: 60 * 1000,
  queryFn: ({ pageParam }) =>
    httpService.panel
      .panelUsersAvailabilityOptionsIdsList({
        page: pageParam,
        search: params.search,
        semester_id: params.semesterId
      })
      .then(parsePaginatedOptions),

  getNextPageParam: nextPageParamGetter,
  initialPageParam: 1
})
